import Text from "@/components/Text";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerFooter } from "@/components/ui/drawer";
import useDetectSizeDevice from "@/hooks/useDetectSizeDevice";
import { createCheckoutSession } from "@/store/checkoutSessionState";
import { listProductsState } from "@/store/listProductsState";
import { setPaymentAction } from "@/store/paymentActionState";
import { setActionTriggerModalTrialModal } from "@/store/restrictedFeatureState";
import { X } from "lucide-react";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

const ModalFreeTrial: FC = () => {
  const { sm } = useDetectSizeDevice();
  const { t } = useTranslation();
  const { data: listProducts } = listProductsState();

  const explorerProduct =
    listProducts?.find((product) => product.name === "Explorer") ?? undefined;

  if (!sm) {
    return (
      <Drawer
        open={true}
        onOpenChange={(open) => {
          if (!open) {
            setActionTriggerModalTrialModal(false);
          }
        }}
      >
        <DrawerContent>
          <div className="flex flex-col gap-[24px] p-[16px] overflow-y-auto">
            <div className="w-[100%] flex justify-end">
              <X
                className="cursor-pointer"
                onClick={() => {
                  setActionTriggerModalTrialModal(false);
                }}
              />
            </div>
            <img src="/img/free-trial.png" className="rounded-[8px]" />
            <div className="flex flex-col gap-[8px]">
              <Text fontSize={20} fontWeight={600}>
                {t("free_trial_title")}
              </Text>
              <div>
                <Text fontSize={14} fontWeight={400}>
                  {t("free_trial_title_subtitle")}
                </Text>
              </div>
            </div>
            <div>
              <Text fontSize={16} fontWeight={600} color="#454F59">
                {t("limited_free_trial_description_1")}
              </Text>
              <div className="flex gap-[8px] flex-wrap mt-[8px]">
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_5")}
                  </Text>
                </div>
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_8")}
                  </Text>
                </div>
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_9")}
                  </Text>
                </div>
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_10")}
                  </Text>
                </div>
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_11")}
                  </Text>
                </div>
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_2")}
                  </Text>
                </div>

                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_4")}
                  </Text>
                </div>

                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_6")}
                  </Text>
                </div>
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_3")}
                  </Text>
                </div>
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_12")}
                  </Text>
                </div>
                <div
                  className=" py-[4px] px-[12px] rounded-[40px]"
                  style={{ border: "1px solid #E0E0E0" }}
                >
                  <Text fontSize={14} fontWeight={400}>
                    {t("limited_query_description_13")}
                  </Text>
                </div>
              </div>
            </div>
            <DrawerFooter className="flex flex-col gap-[12px]">
              <Link
                to="/upgrade"
                onClick={() => {
                  setActionTriggerModalTrialModal(false);
                }}
              >
                <Button className="w-[100%]" variant="secondaryFilled">
                  {t("later")}
                </Button>
              </Link>
              <Button
                className="w-[100%]]"
                onClick={() => {
                  if (explorerProduct && explorerProduct.defaultPrice) {
                    createCheckoutSession({
                      priceId: explorerProduct.defaultPrice,
                    });
                    setPaymentAction("explorer");
                    setActionTriggerModalTrialModal(false);
                  }
                }}
              >
                {t("start_free_trial")}
              </Button>
            </DrawerFooter>
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={true}>
      <DialogContent showCloseButton={false}>
        <DialogDescription className="flex flex-col gap-[24px]">
          <div className="w-[100%] flex justify-end">
            <X
              className="cursor-pointer"
              onClick={() => {
                setActionTriggerModalTrialModal(false);
              }}
            />
          </div>
          <img src="/img/free-trial.png" className="rounded-[8px]" />
          <div className="flex flex-col gap-[8px]">
            <Text fontSize={20} fontWeight={600}>
              {t("free_trial_title")}
            </Text>
            <div>
              <Text fontSize={14} fontWeight={400}>
                {t("free_trial_title_subtitle")}
              </Text>
            </div>
          </div>
          <div>
            <Text fontSize={16} fontWeight={600} color="#454F59">
              {t("limited_free_trial_description_1")}
            </Text>
            <div className="flex gap-[8px] flex-wrap mt-[8px]">
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_5")}
                </Text>
              </div>
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_8")}
                </Text>
              </div>
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_9")}
                </Text>
              </div>
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_10")}
                </Text>
              </div>
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_11")}
                </Text>
              </div>
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_2")}
                </Text>
              </div>

              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_4")}
                </Text>
              </div>

              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_6")}
                </Text>
              </div>
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_3")}
                </Text>
              </div>
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_12")}
                </Text>
              </div>
              <div
                className=" py-[4px] px-[12px] rounded-[40px]"
                style={{ border: "1px solid #E0E0E0" }}
              >
                <Text fontSize={14} fontWeight={400}>
                  {t("limited_query_description_13")}
                </Text>
              </div>
            </div>
          </div>
        </DialogDescription>

        <DialogFooter className="grid grid-cols-2 gap-[16px] mt-[12px]">
          <Link
            to="/upgrade"
            onClick={() => {
              setActionTriggerModalTrialModal(false);
            }}
          >
            <Button className="w-[100%]" variant="secondaryFilled">
              {t("later")}
            </Button>
          </Link>
          <Button
            className="w-[100%]"
            onClick={() => {
              if (explorerProduct && explorerProduct.defaultPrice) {
                createCheckoutSession({
                  priceId: explorerProduct.defaultPrice,
                });
                setPaymentAction("explorer");
                setActionTriggerModalTrialModal(false);
              }
            }}
          >
            {t("start_free_trial")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ModalFreeTrial;
